import type { ReactNode } from 'react'

import { t } from '../../../../../common/i18n.js'
import { Language } from '../../../../../common/types/i18n.js'
import {
    Cake,
    CalendarClock,
    LogOut,
    PartyPopper,
    UserPlus,
} from '../../../../components/icon/solar-icons.js'
import type { UpcomingEvent, UpcomingEventType } from '../../utils/portal-api.js'

/** Icon for a people-lifecycle event type. Shared by the Events tab and the
 *  inline directory-row badges so both stay in sync. */
export const eventIcon = (type: UpcomingEventType): ReactNode => {
    switch (type) {
        case 'birthday':
            return <Cake size={16} />
        case 'anniversary':
            return <PartyPopper size={16} />
        case 'first_day':
            return <UserPlus size={16} />
        case 'probation_end':
            return <CalendarClock size={16} />
        case 'offboarding':
            return <LogOut size={16} />
    }
}

/** Localised label for an event (anniversaries show the completed-year count). */
export const eventLabel = (event: UpcomingEvent, lang: Language): string => {
    const ph = t.portal.people
    switch (event.type) {
        case 'birthday':
            return ph.evBirthday(lang)
        case 'anniversary':
            return event.years && event.years > 0
                ? ph.evAnniversaryYears(event.years)(lang)
                : ph.evAnniversary(lang)
        case 'first_day':
            return ph.evFirstDay(lang)
        case 'probation_end':
            return ph.evProbationEnd(lang)
        case 'offboarding':
            return ph.evOffboarding(lang)
    }
}
